<template>
    <li>
        <div class="desc">
        <h3 v-html="data.key"></h3>
        <p>
            <template v-if="content" v-for="(content, i) in contentList">
                  <div class="d-text" :key="keyParam + i" v-if="content.acf_fc_layout === 'text'" v-html="content.text"></div>
                  <div v-html="content.map" class="d-map" :key="keyParam + i" v-else-if="content.acf_fc_layout === 'map'">
                  </div>
                  <div class="d-pdf" :key="keyParam + i" v-else-if="content.acf_fc_layout === 'btn_pdf'">
                    <a target="_blank" class="download-btn pdf alp" v-if="content.btn_pdf" :href="content.btn_pdf.url"><span>応募書類をダウンロードする</span></a>
                  </div>
            </template>
        </p>
        </div>
    </li>
</template>

<style lang="scss">
.d-map {
  height: 342px;
  margin: 15px 0 15px -159px;
  iframe {
    height: 342px;
    width: 900px;
    position: absolute;
  }
}
@media only screen and (max-width: 750px) {
.d-map {
    height: 0;
    padding-top: 50%;
    margin: 2.5vw 0 2.5vw 0;
    position: relative;
    iframe {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
$event: #2eb024;
li {
  border-bottom: 1px solid #d6d6d6;
  .desc {
    @include flex();
    padding: 25px 0;
    h3 {
      font-size: 18px;
      font-weight: bold;
      color: $event;
      line-height: 1.6;
      margin-right: 1%;

      width: 18.5%;
    }
    p {
      font-size: 15px;
      width: 91.5%;
      line-height: 1.8;
      & > div:first-child.d-map {
        margin-top: 40px;
      }
    }
  }
  .map {
    height: 334px;
    border: 1px solid #ddd;
    margin-bottom: 30px;
  }
}
li:last-child {
  border-bottom: none;
}
.download-btn {
  width: 54%;
  margin: 20px 0 0;
  margin-left: 12.5%;
  background: $event;
  color: #fff;
  span {
    padding-left: 30px;
    background-image: url(../../assets/img/common/ico_download.png);
    background-repeat: no-repeat;
    background-size: 17px auto;
    background-position: center left;
  }
}


@media only screen and (max-width: 750px) {
  li {
    .desc {
      display: block;
      padding: 5vw 0;
      h3 {
        width: 100%;
        font-size: 1.11rem;
        margin-bottom: 0.5vw;
      }
      p {
        width: 100%;
        font-size: 1.025rem;
        line-height: 1.4;
        & > div:first-child.d-map {
          margin-top: 2.5vw;
        }
      }
    }
    .map {
      height: 44vw;
      margin-bottom: 5vw;
    }
  }

  li:last-child {
    border-bottom: 1px solid #d6d6d6;
  }

  .download-btn {
    margin-top: 2.5vw;
    margin-bottom: 2.5vw;
    margin-left: 0;
  }
  
}
</style>

<style lang="scss">
$event: #2eb024;
.event-detail {
  article .desc p {
    font-size: 15px;
    line-height: 1.73;
    color: #333;
    a:not(.download-btn) {
      color: $event;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
  @media only screen and (max-width: 750px) {
    article .desc p {
      font-size: 1.025rem;
      line-height: 1.5;
      a:not(.download-btn) {
        text-decoration: underline;
      }
    }
  }
}
</style>

<script>
export default {
  props: ["data"],
  data() {
    return {
      keyParam: null
    };
  },
  computed: {
    contentList() {
      return (this.data || {}).content || [];
    }
  },
  mounted() {
    this.keyParam = "c" + new Date().getTime();
  }
};
</script>
